import { inject, Injectable } from '@angular/core';
import { useFirmwareStore } from '@ottobock/remote-update/domain';

@Injectable({
  providedIn: 'root'
})
export class FirmwarePackageDetailsService {
  private store = inject(useFirmwareStore);
  getFirmwarePackageDetails(packageId: number) {
    return this.store.loadAllPackageDetails(packageId);
  }

  getPackageChangeHistory(packageId: number) {
    return this.store.loadAllPackageChangeHistory(packageId);
  }

  releaseFirmwarePackage(packageId: number) {
    return this.store.releasePackage(packageId);
  }

  deleteFirmwarePackage(packageId: number) {
    return this.store.deleteFirmwarePackage(packageId);
  }

  withdrawFirmwarePackage(packageId: number){
    return this.store.withdrawFirmwarePackage(packageId)
  }
}
